import { createSelector } from 'reselect'

const quiz_question_selector = questionId => createSelector(
	[ state => state.quiz ],
	quizState => {
		const question = quizState.questions.find(question => question.id === questionId)
		const orden = quizState.questions.findIndex(question => question.id === questionId)
		return {
			entityUID: quizState.entityUID,
			presentationId: quizState.presentationId,
			text: question.text,
			serverId: question.serverId,
			icon: question.icon,
			answers: question.answers,
			orden,
		}
	}
)

export default quiz_question_selector
